const AppPaths = {
  HOME: "/",
  CHAT_ROOM: "/c/:chatId",
  LOGIN: "/login",
  SIGN_UP: "/signup",
};

export default AppPaths;
